import { MenuItem, Select } from '@mui/material'
import Box from '@mui/material/Box'
import React from 'react'
import { Cookies } from 'react-cookie'
import { useSelector } from 'react-redux'
import { useDefaultComponentTools } from '../../../hooks/useDefaultComponentTools'
import i18n from '../../../i18n/i18n'
import { selectAccessToken } from '../../../store/redusers/auth/selectors'
import { getJsonAction } from '../../../store/redusers/user/actions'
import AppIconDouble from '../../AppIconDouble'
import { getSimpleLang } from '../../../helpers'

const SelectLang = () => {
	const {dispatch} = useDefaultComponentTools()
	const cookies = new Cookies()
	const cookieAccessToken = cookies.get('oauth_access_token')
	const accessToken = useSelector(selectAccessToken)
	// const langList = [
	// 	{iso_code: 'en', name: 'English'},
	// 	{iso_code: 'fr', name: 'français'},
	// 	{iso_code: 'de', name: 'Deutsch'},
	// 	{iso_code: 'es', name: 'español'},
	// 	{iso_code: 'pt-br', name: 'português'},
	// 	{iso_code: 'pt-pt', name: 'português'},
	// 	{iso_code: 'it', name: 'italiano'},
	// 	{iso_code: 'ja', name: '日本語'},
	// 	{iso_code: 'ar', name: 'اَلْعَرَبِيَّةُ'},
	// 	{iso_code: 'el', name: 'Ελληνικα'},
	// 	{iso_code: 'ru', name: 'Русский'},
	// 	{iso_code: 'zh-hans', name: '简体中文'}
	// ]
	const langList = window.TRADING_APP_LANGUAGE_AVAILABLE
	const  handleChange = (event) => {
		let lang = event.target.value
		let path
		let pathArr = window.location.pathname.split('/')
		if (i18n.language === 'en') {
			pathArr.splice(1, 0, lang)
		} else {
			if (lang === 'en') {
				pathArr.splice(1, 1)
			} else {
				pathArr.splice(1, 1, lang)
			}
		}
		path = pathArr.join('/')
		window.location.pathname = path
		dispatch(getJsonAction(cookieAccessToken || accessToken, getSimpleLang(lang)))
	}

	return (
		<Box >
			{langList && langList?.length > 1 ? <Select
				sx={{'.MuiInputBase-input': {paddingRight: '25px'}, '.MuiSelect-select': {padding: 0}}}
				defaultValue={i18n.language.toLowerCase() || 'en'}
				onChange={handleChange}
				inputProps={{
					id: 'uncontrolled-native',
					name: 'lang'
				}}
			>
				{langList.map((lang, index) => <MenuItem
					title={lang.name}
					key={lang.iso_code + index}
					value={lang.iso_code}>
					<AppIconDouble name={lang.iso_code} size={20}/>
				</MenuItem>)}
			</Select> : null}
		</Box>
	)
}

export default SelectLang
